import api from '../../plugins/api';

// ÐÐ¾Ð²ÑÐ¾ÑÐ½ÑÐ¹ Ð·Ð°Ð¿ÑÑÐº Ð¿ÑÐ¾Ð²ÐµÑÐ¾Ðº Ð²Ð»Ð°Ð´ÐµÐ»ÑÑÐ° (Ð¿.6, PUT /owner/restart).
// ÐÑÐ¶ÐµÐ½ Ð¿Ð¾ÑÐ»Ðµ ÑÑÐºÐ° OWNER_ON_REVISION: Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð¾Ð±Ð½Ð¾Ð²Ð»ÑÐµÑ Ð´Ð°Ð½Ð½ÑÐµ Ð²Ð»Ð°Ð´ÐµÐ»ÑÑÐ°
// Ð² Ð¦ÐÐ Ð¸ Ð·Ð°Ð½Ð¾Ð²Ð¾ Ð·Ð°Ð¿ÑÑÐºÐ°ÐµÑ Ð¿ÑÐ¾Ð²ÐµÑÐºÑ.
const ffinRestartOwner = ({ appealId }) => {
  return api.put('/api/bank/ffin/owner/restart', { appealId });
};

export default ffinRestartOwner;
